module.exports = __webpack_public_path__ + "img/slide4.af2fca43.jpg";